'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var initialState = {
  gates: []
};
var auth = function auth() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments[1];
  var type = action.type,
      payload = action.payload;

  switch (type) {
    case _ActionTypes.INITIALIZE_AUTH:
      return {
        user: payload.user,
        gates: payload.gates,
        portal: payload.portal
      };
    default:
      return state;
  }
};

exports.default = auth;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/Auth.js
// module id = 379
// module chunks = 3 4 5